module.exports = __webpack_public_path__ + "static/media/icon_terrace.4ce8fc77.svg";